<template>
  <div class="invoice-page">
    <navigation :adaption="true">发票管理</navigation>
    <div class="invoice-content">
      <!-- 顶部背景装饰 -->
      <div class="header-bg">
        <div class="header-bg-circle"></div>
        <div class="header-info">
          <p class="header-title">发票服务</p>
          <p class="header-desc">轻松管理您的电子发票</p>
        </div>
      </div>

      <!-- 两个入口卡片 -->
      <div class="entry-list">
        <div class="entry-card" @click="$router.push('/invoice/progress')">
          <div class="entry-icon progress-icon">
            <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4zm0 4c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24 15.163 8 24 8z" fill="rgba(255,70,51,0.2)"/>
              <path d="M24 10a2 2 0 012 2v10.586l6.707 6.707a2 2 0 01-2.828 2.828l-7.414-7.414A2 2 0 0122 24V12a2 2 0 012-2z" fill="#FF4633"/>
            </svg>
          </div>
          <div class="entry-info">
            <p class="entry-title">查看发票进度</p>
            <p class="entry-desc">查看已申请发票的开具状态</p>
          </div>
          <div class="entry-arrow">
            <svg viewBox="0 0 16 28" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3l11 11-11 11" stroke="#CCCCCC" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="entry-card" @click="$router.push('/invoice/apply')">
          <div class="entry-icon apply-icon">
            <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 6h32a2 2 0 012 2v32a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2z" fill="rgba(255,70,51,0.2)" rx="4"/>
              <path d="M14 16h20M14 24h14M14 32h18" stroke="#FF4633" stroke-width="3" stroke-linecap="round"/>
              <path d="M34 28l4 4-4 4" stroke="#FF4633" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="entry-info">
            <p class="entry-title">申请发票</p>
            <p class="entry-desc">在线申请开具电子发票</p>
          </div>
          <div class="entry-arrow">
            <svg viewBox="0 0 16 28" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3l11 11-11 11" stroke="#CCCCCC" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>

      <!-- 底部提示 -->
      <div class="tips">
        <div class="tips-item">
          <span class="tips-dot"></span>
          <span>发票将在审核通过后开具</span>
        </div>
        <div class="tips-item">
          <span class="tips-dot"></span>
          <span>电子发票与纸质发票具有同等法律效力</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InvoiceIndex',
  async created () {
    // 从人脸识别成功后返回
    if (this.$route.query.result === 'PASS') {
      const storedBillNos = JSON.parse(this.$storage.get('invoice_apply_billNos') || '[]')
      if (storedBillNos.length) {
        this.$storage.set('invoice_apply_billNos', '')
        this.doSubmitApply(storedBillNos)
        this.$bus.$emit('ready')
        return
      }
    }
    await this.getInvoiceIouListX()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('invoice', ['getInvoiceIouListX', 'submitInvoiceApplyX']),
    async doSubmitApply (billNos) {
      this.submitting = true
      try {
        const res = await this.submitInvoiceApplyX({ billNos })
        if (res.code === '000000') {
          this.$router.push({ path: '/invoice/detail', query: { applyNo: res.data.applyNo } })
        }
      } catch (e) {
        console.error('提交申请失败', e)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.invoice-page {
  min-height: 100vh;
  background-color: #F7F7F7;
  overflow-y: auto;
}

.invoice-content {
  padding: 0 40px;
}

.header-bg {
  position: relative;
  height: 320px;
  background: linear-gradient(135deg, #FF4633 0%, #FF7B54 100%);
  border-radius: 0 0 40px 40px;
  margin: 0 -40px;
  padding: 60px 40px 0;
  overflow: hidden;

  &-circle {
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    top: -100px;
    right: -60px;
  }

  .header-info {
    position: relative;
    z-index: 1;
  }

  .header-title {
    font-size: 44px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 60px;
    margin-bottom: 12px;
  }

  .header-desc {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(255, 255, 255, 0.8);
    line-height: 36px;
  }
}

.entry-list {
  margin-top: -50px;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.entry-card {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 40px 36px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
}

.entry-icon {
  width: 96px;
  height: 96px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 30px;

  svg {
    width: 48px;
    height: 48px;
  }

  &.progress-icon {
    background: linear-gradient(135deg, #FFF1F0 0%, #FFE4E1 100%);
  }

  &.apply-icon {
    background: linear-gradient(135deg, #FFF7E6 0%, #FFEFD5 100%);

    svg path:first-child {
      fill: rgba(255, 149, 0, 0.2) !important;
    }

    svg path:nth-child(2),
    svg path:nth-child(3) {
      stroke: #FF9500 !important;
    }
  }
}

.entry-info {
  flex: 1;

  .entry-title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 44px;
    margin-bottom: 8px;
  }

  .entry-desc {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #999999;
    line-height: 34px;
  }
}

.entry-arrow {
  flex-shrink: 0;
  width: 16px;
  height: 28px;

  svg {
    width: 16px;
    height: 28px;
  }
}

.tips {
  margin-top: 48px;
  padding: 30px 36px;
  background-color: #FFFFFF;
  border-radius: 20px;

  .tips-item {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #999999;
    line-height: 40px;

    & + .tips-item {
      margin-top: 16px;
    }
  }

  .tips-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #CCCCCC;
    margin-right: 16px;
    flex-shrink: 0;
  }
}
</style>
